<template>
  <div class="mc-download__list-item">
    <div class="mc-download__list-item-wrapper d-flex">
      <i class="mc-fa icon-fill_videorecord"></i>
      <div class="mc-download__list-item-text">
        <p
          :title="`${licensePlate} ${convertedChannel} - ${momentDMYH(
            convertUtcToLocalDate(startTime, deviceTimezone)
          )} - ${momentDMYH(convertUtcToLocalDate(endTime, deviceTimezone))}`"
        >
          {{ licensePlate }} {{ convertedChannel }} -
          {{ momentDMYH(convertUtcToLocalDate(startTime, deviceTimezone)) }}
          -
          {{ momentDMYH(convertUtcToLocalDate(endTime, deviceTimezone)) }}
        </p>
        <p>
          <span class="red-500">
            <i class="mc-fa icon-fill_alert-triangle" />
            {{ $t('videoHistory.widgetDownload.failedDownload') }}
          </span>
          <span> {{ momentDMYH(downloadOn) }}</span>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import { Helper } from '@/mixin/helper'
export default {
  name: 'VideoFailed',
  mixins: [Helper],
  props: {
    licensePlate: {
      type: String,
      required: true,
    },
    convertedChannel: {
      type: [String, Number],
      required: true,
    },
    deviceTimezone: {
      type: [String, Number],
      required: true,
    },
    startTime: {
      type: String,
      required: true,
    },
    endTime: {
      type: String,
      required: true,
    },
    downloadOn: {
      type: String,
      required: true,
    },
  },
}
</script>
